import React, { useState, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText, Avatar, Typography, Collapse, Button } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import PersonIcon from '@material-ui/icons/Person';
import ExpandMore from '@material-ui/icons/ExpandMore';
import WorkIcon from '@material-ui/icons/Work';
import HomeIcon from '@material-ui/icons/Home';
import { AccountContext } from '../AccountContext';  // Import authentication context

import '../assets/styles/Navbar.css';

const Navbar = () => {
    const [workspaceOpen, setWorkspaceOpen] = useState(false);
    const { isAuthenticated, setIsAuthenticated, user } = useContext(AccountContext);
    const history = useHistory();

    const handleWorkspaceClick = () => {
        setWorkspaceOpen(!workspaceOpen);
    };

    const handleLogout = () => {
        console.log("Logging out...");
        localStorage.clear();
        sessionStorage.clear();
        setIsAuthenticated(false);
        history.push('/login');
    };

    return (
        <div className='navbar'>
            <List>
                <ListItem>
                    <Typography variant="h5" component="div" className='fancyFont'>Real-Time</Typography>
                </ListItem>
                <ListItem button component={Link} to='/'>
                    <ListItemIcon style={{ color: "#fff" }}><HomeIcon /></ListItemIcon>
                    <ListItemText primary='Home' />
                </ListItem>
                <ListItem button onClick={handleWorkspaceClick}>
                    <ListItemIcon style={{ color: "#fff" }}><WorkIcon /></ListItemIcon>
                    <ListItemText primary='Workspace' />
                    {workspaceOpen ? <ExpandLess className="anti-pizza" style={{ color: "#fff" }} /> : <ExpandMore className="anti-pizza" style={{ color: "#fff" }} />}
                </ListItem>
                <Collapse in={workspaceOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button component={Link} to="/smart-search" className='nested smart'>
                            <ListItemText primary="Smart Search" />
                        </ListItem>
                        <ListItem button component={Link} to="/smart-cma" className='nested smart'>
                            <ListItemText primary="Smart CMA" />
                        </ListItem>
                        <ListItem button component={Link} to="/smart-reports" className='nested smart'>
                            <ListItemText primary="Smart Reports" />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button component={Link} to="/contacts">
                    <ListItemIcon style={{ color: "#fff" }}><PersonIcon /></ListItemIcon>
                    <ListItemText primary='Contacts' />
                </ListItem>

                {isAuthenticated ? (
                    <>
                        <ListItem>
                            <Avatar className="pizza" alt="User Initial" style={{ backgroundColor: '#3f51b5' }}>
                                {user && user["custom:firstName"] ? user["custom:firstName"][0] : "U"}
                            </Avatar>
                            <ListItemText primary={
                                user && user["custom:firstName"] && user["custom:lastName"]
                                    ? `${user["custom:firstName"]} ${user["custom:lastName"][0]}.`
                                    : "User"
                            } />
                        </ListItem>
                        <ListItem>
                            <Button variant="contained" color="primary" onClick={handleLogout} fullWidth>
                                Logout
                            </Button>
                        </ListItem>
                    </>
                ) : (
                    <ListItem>
                        <Button variant="contained" color="primary" component={Link} to="/login" fullWidth>
                            Login
                        </Button>
                    </ListItem>
                )}
            </List>
        </div>
    );
}

export default Navbar;